export enum CHECKBOX_VARIANT {
  LOG_IN = 'Log in',
  FINANCE_ACCOUNT = 'Finance account',
}
